import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

/* ------------- Reducer ------------- */
const defaultState = {
  loadingInfo: true,
  info: null,
  infoError: null,
  loadingCollections: true,
  collections: null,
  collectionsError: null,
  page: 0,
  loadingPage: 1,
  totalPages: 1,
  makingAsign: false,
  assignError: null,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.LOAD_INFO_START: {
      return state.merge({
        loadingInfo: true,
        info: null,
        infoError: null,
      });
    }
    case actions.LOAD_INFO_SUCCESS: {
      const { info } = action.payload;
      return state.merge({
        info,
        loadingInfo: false,
        infoError: null,
      });
    }
    case actions.LOAD_INFO_FAIL: {
      const { error: infoError } = action.payload;
      return state.merge({
        infoError,
        loadingInfo: false,
        info: null,
      });
    }
    case actions.LOAD_COLLECTIONS_START: {
      const { page: loadingPage } = action.payload;
      return state.merge({
        loadingPage,
        loadingCollections: true,
        collectionsError: null,
      });
    }
    case actions.LOAD_COLLECTIONS_SUCCESS: {
      const oldCollections = state.collections || [];
      const { collections, page, totalPages } = action.payload;
      if (page < state.loadingPage) {
        return state;
      }
      const newCollections = collections.map(collection => ({
        ...collection,
        loading: true,
        products: null,
        error: null,
        loadingPage: 1,
        page: 0,
      }));
      return state.merge({
        page,
        totalPages,
        loadingCollections: false,
        collectionsError: null,
        collections: [...oldCollections, ...newCollections],
        loadingPage: page + 1,
      });
    }
    case actions.LOAD_COLLECTIONS_FAIL: {
      const { error: collectionsError } = action.payload;
      return state.merge({
        collectionsError,
        loadingCollections: false,
      });
    }
    case actions.LOAD_COLLECTION_PRODUCTS_START: {
      const { id, page: loadingPage } = action.payload;
      const oldCollections = state.collections || [];
      const collection = oldCollections.find(c => c.id === id);
      if (!collection || loadingPage < collection.loadingPage) {
        return state;
      }
      const newCollection = Immutable(collection).merge({
        loadingPage,
        loading: true,
        error: null,
      });
      const index = oldCollections.indexOf(collection);
      const newList = [...oldCollections];
      newList[index] = newCollection;
      return state.merge({
        collections: newList,
      });
    }
    case actions.LOAD_COLLECTION_PRODUCTS_SUCCESS: {
      const {
        id, products, page, totalPages,
      } = action.payload;
      const oldCollections = state.collections || [];
      const collection = oldCollections.find(c => c.id === id);
      const index = oldCollections.indexOf(collection);
      if (!collection) {
        return state;
      }
      const newCollection = Immutable(collection).merge({
        totalPages,
        products: [...products],
        loading: false,
        error: null,
        loadingPage: page + 1,
      });
      const newList = [...oldCollections];
      newList[index] = newCollection;
      return state.merge({
        collections: newList,
      });
    }
    case actions.LOAD_COLLECTION_PRODUCTS_FAIL: {
      const { id, error } = action.payload;
      const oldCollections = state.collections || [];
      const collection = oldCollections.find(c => c.id === id);
      const index = oldCollections.indexOf(collection);
      if (!collection) {
        return state;
      }
      const newList = [...oldCollections];
      const newCollection = Immutable(collection).merge({
        loading: false,
        error,
      });
      newList[index] = newCollection;
      return state.merge({
        collections: newList,
      });
    }
    case actions.START_ASSIGN: {
      return state.merge({
        makingAsign: true,
        assignError: null,
      });
    }
    case actions.END_ASSIGN_SUCCESS: {
      const { assigned } = action.payload;
      const info = Immutable(state.info).merge({
        assigned,
      });
      return state.merge({
        info,
        makingAsign: false,
      });
    }
    case actions.END_ASSIGN_FAIL: {
      const { error: assignError } = action.payload;
      return state.merge({
        assignError,
        makingAsign: false,
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

export const propTypes = {
};



// WEBPACK FOOTER //
// ./src/redux/Manufacturer/reducer.js